// Local translations
export const T = {
  en_GB: {
    attachments: "Attachments",
    attachmentsDescription:
      "Static PDF documents appended to the end of every generated PDF, in order. Each attachment can be included conditionally.",
    uploadAttachment: "Upload PDF",
    uploading: "Uploading...",
    noAttachments: "No attachments yet. Upload a PDF to append it to generated documents.",
    pages: "pages",
    page: "page",
    conditional: "Conditional",
    moveUp: "Move up",
    moveDown: "Move down",
    editCondition: "Edit condition",
    deleteAttachment: "Delete attachment",
    deleteConfirmation: (name: string) => `Are you sure you want to delete "${name}"?`,
    delete: "Delete",
    cancel: "Cancel",
    save: "Save",
    error: "Error",
    invalidFileType: "Only PDF files are allowed",
    fileTooLarge: "File too large. Max size: 10 MB",
    uploadFailed: "Failed to upload attachment",
    deleteFailed: "Failed to delete attachment",
    saveFailed: "Failed to save condition",
    reorderFailed: "Failed to reorder attachments",
    attachmentUploaded: "Attachment uploaded",
    attachmentDeleted: "Attachment deleted",
    conditionSaved: "Saved",
    // Conditional dialog
    conditionalInclusion: "Conditional Inclusion",
    conditionalInclusionDescription:
      "Include this attachment only when a condition is met. When disabled, the attachment is always included.",
    enableCondition: "Enable condition",
    when: "When",
    selectField: "Select a field...",
    searchFields: "Search fields…",
    noFieldsAvailable: "No fields available.",
    noFieldsMatch: "No fields match your search.",
    condition: "Condition",
    isEmpty: "Is Empty",
    isNotEmpty: "Is Not Empty",
    contains: "Contains",
    notContains: "Does Not Contain",
    value: "Value",
    selectValue: "Select a value...",
    searchCountries: "Search countries…",
    noCountriesMatch: "No countries match your search.",
    enterValue: "Enter value...",
    // Field labels
    flowStatus: "Flow Status",
    clientCountry: "Client Country",
    clientType: "Client Type",
    classificationType: "Classification Type",
    trapetsPep: "Trapets: PEP Status",
    trapetsSanctioned: "Trapets: Sanctioned Status",
    sumsubVerified: "Sumsub: Verified Status",
    sumsubDocumentCountry: "Sumsub: Document Country",
    followupMode: "Follow-up Mode",
    followupModeYes: "Yes",
    followupModeNo: "No",
    clientField: "Client Field:",
    quizField: "Quiz:",
    flowField: "Flow Field:",
  },
  nb_NO: {
    attachments: "Vedlegg",
    attachmentsDescription:
      "Statiske PDF-dokumenter som legges til på slutten av hver genererte PDF, i rekkefølge. Hvert vedlegg kan inkluderes betinget.",
    uploadAttachment: "Last opp PDF",
    uploading: "Laster opp...",
    noAttachments:
      "Ingen vedlegg ennå. Last opp en PDF for å legge den til i genererte dokumenter.",
    pages: "sider",
    page: "side",
    conditional: "Betinget",
    moveUp: "Flytt opp",
    moveDown: "Flytt ned",
    editCondition: "Rediger betingelse",
    deleteAttachment: "Slett vedlegg",
    deleteConfirmation: (name: string) => `Er du sikker på at du vil slette "${name}"?`,
    delete: "Slett",
    cancel: "Avbryt",
    save: "Lagre",
    error: "Feil",
    invalidFileType: "Kun PDF-filer er tillatt",
    fileTooLarge: "Filen er for stor. Maks størrelse: 10 MB",
    uploadFailed: "Kunne ikke laste opp vedlegg",
    deleteFailed: "Kunne ikke slette vedlegg",
    saveFailed: "Kunne ikke lagre betingelse",
    reorderFailed: "Kunne ikke endre rekkefølge på vedlegg",
    attachmentUploaded: "Vedlegg lastet opp",
    attachmentDeleted: "Vedlegg slettet",
    conditionSaved: "Lagret",
    // Conditional dialog
    conditionalInclusion: "Betinget inkludering",
    conditionalInclusionDescription:
      "Inkluder dette vedlegget bare når en betingelse er oppfylt. Når deaktivert, inkluderes vedlegget alltid.",
    enableCondition: "Aktiver betingelse",
    when: "Når",
    selectField: "Velg et felt...",
    searchFields: "Søk i felt…",
    noFieldsAvailable: "Ingen felt tilgjengelig.",
    noFieldsMatch: "Ingen felt samsvarer med søket.",
    condition: "Betingelse",
    isEmpty: "Er tom",
    isNotEmpty: "Er ikke tom",
    contains: "Inneholder",
    notContains: "Inneholder ikke",
    value: "Verdi",
    selectValue: "Velg en verdi...",
    searchCountries: "Søk i land…",
    noCountriesMatch: "Ingen land samsvarer med søket.",
    enterValue: "Skriv inn verdi...",
    // Field labels
    flowStatus: "Flytstatus",
    clientCountry: "Kundeland",
    clientType: "Kundetype",
    classificationType: "Klassifiseringstype",
    trapetsPep: "Trapets: PEP-status",
    trapetsSanctioned: "Trapets: Sanksjonsstatus",
    sumsubVerified: "Sumsub: Verifiseringsstatus",
    sumsubDocumentCountry: "Sumsub: Dokumentland",
    followupMode: "Oppfølgingsmodus",
    followupModeYes: "Ja",
    followupModeNo: "Nei",
    clientField: "Kundefelt:",
    quizField: "Quiz:",
    flowField: "Flytfelt:",
  },
} as const;
